export interface BackOrderInfo {
  group: BackOrderGroupInfo;
  currentPlan: PlanInformation;
  measurementPeriod: Period;
  currentCreditBalance: number;
}

export interface BackOrderGroupInfo {
  groupId: string;
  groupName: string;
  groupAdminUserId: number;
  groupAdminEmail: string;
}

export interface Period {
  startDate: string;
  endDate: string | null;
}

export interface PlanInformation {
  subscriptionId: number;
  plan: ClosetSubscriptionType;
  planType: string;
  paymentMethod: string;
  orderDate: string | null;
  subscriptionPeriod: Period;
  currentCreditBalance: number;
  backorderByEmail: string;
  canStartDateEdit: boolean;
  canEndDateEdit: boolean;
}

export type PickEnum<T, K extends T> = {
  [P in keyof K]: P extends K ? P : never;
};
export type BackOrderSubscriptionType = PickEnum<
  ClosetSubscriptionType,
  | ClosetSubscriptionType.PREMIUM_TRIAL
  | ClosetSubscriptionType.STANDARD_TRIAL
  | ClosetSubscriptionType.PREMIUM_INVOICE_PAYMENT
  | ClosetSubscriptionType.STANDARD_INVOICE_PAYMENT
  | ClosetSubscriptionType.ACADEMIC
>;

export type BackOrderOfferCreditSubscriptionType = PickEnum<
  BackOrderSubscriptionType,
  ClosetSubscriptionType.STANDARD_INVOICE_PAYMENT | ClosetSubscriptionType.PREMIUM_INVOICE_PAYMENT
>;

// group 과금 플랜 타입
export enum ClosetSubscriptionType {
  NONE,
  FREE,
  TRIAL,
  ADVANCED,
  ENTERPRISE,
  ADVANCED_PLAN_INV,
  STANDARD,
  PREMIUM,
  STANDARD_TRIAL,
  PREMIUM_TRIAL,
  STANDARD_INVOICE_PAYMENT,
  PREMIUM_INVOICE_PAYMENT,
  ACADEMIC,
  NEW_FREE = 99,
}

interface Paging<T> {
  currentPage: number;
  items: T[];
  pageSize: number;
  totalItems: number;
  totalPages: number;
}

export type BackOrderHistoryResponse = Paging<BackOrderHistory>;
export interface BackOrderHistory
  extends Pick<
    PlanInformation,
    | 'subscriptionId'
    | 'plan'
    | 'planType'
    | 'paymentMethod'
    | 'orderDate'
    | 'subscriptionPeriod'
    | 'backorderByEmail'
    | 'canStartDateEdit'
    | 'canEndDateEdit'
  > {
  status: string | null;
  creditBalance: number;
  reservedCredit: number;
}

export type BackOrderCommentResponse = Paging<BackOrderComment>;
export interface BackOrderComment {
  no: number;
  backOrder: number;
  description: string;
  postedDate: string;
  operator: string;
}

export interface ClosetUserCount {
  totalUserCount: number;
  supportUserCount: number;
}
